module.exports = __webpack_public_path__ + "img/newcar.f9caaea4.jpg";